export default "__VITE_ASSET__DC5UT2Cn__"